import { GlobalAxios } from "../axios/axios-config";
import {
  IIndividualBeneficiaryRefundListData,
  IIndividualBeneficiaryRefundMediaFileListData,
} from "../models/individual-beneficiary-refund";
import MainApi from "./mainApi.service";

export const REFUND_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/Refund";

export const individualBeneficiaryRefundService =
  new MainApi<IIndividualBeneficiaryRefundListData>(REFUND_ROUTE);

export const getIndividualBeneficiaryRefundLogs = (
  individualBeneficiaryRefundId: string,
  individualBeneficiaryRefundMediaFileId?: string,
) => {
  return GlobalAxios.get(`${REFUND_ROUTE}/GetRefundLogs`, {
    params: {
      IndividualBeneficiaryRefundId: individualBeneficiaryRefundId,
      IndividualBeneficiaryRefundMediaFileId: individualBeneficiaryRefundMediaFileId,
      PageSize: 50,
    },
  });
};

export const retryRefundIntegration = (individualBeneficiaryRefundId: string) => {
  return GlobalAxios.post(`${REFUND_ROUTE}/RetryRefundIntegration`, {
    individualBeneficiaryRefundId,
  });
};

export const getIndividualBeneficiaryRefundMediaFiles = (
  individualBeneficiaryRefundId: string,
) => {
  return GlobalAxios.get<IIndividualBeneficiaryRefundMediaFileListData[]>(
    `${REFUND_ROUTE}/GetIndividualBeneficiaryRefundMediaFiles`,
    { params: { IndividualBeneficiaryRefundId: individualBeneficiaryRefundId } },
  );
};

export const retryRefundMediaFileIntegration = (
  individualBeneficiaryRefundMediaFileId: string,
) => {
  return GlobalAxios.post(`${REFUND_ROUTE}/RetryRefundMediaFileIntegration`, {
    individualBeneficiaryRefundMediaFileId,
  });
};
